// validation/validationRules.js

export const validationRules = {
  name: {
    required: "Name is required",
    pattern: {
      value: /^[A-Za-z\s]+$/,
      message: "Enter a valid name",
    },
  },
  mother_name: {
    required: "Mother name is required",
    pattern: {
      value: /^[A-Za-z\s]+$/,
      message: "Enter a valid Mother name",
    },
  },
  father_name: {
    required: "Father name is required",
    pattern: {
      value: /^[A-Za-z\s]+$/,
      message: "Enter a valid Father name",
    },
  },

  age: {
    required: "Age is required",
    min: {
      value: 21,
      message: "Choose age from 21 to 58",
    },
    max: {
      value: 58,
      message: "Choose age from 21 to 58",
    },
  },

  mobile: {
    required: "Mobile number is required",
    pattern: {
      value: /^\d{10}$/,
      message: "Mobile number must be exactly 10 digits",
    },
  },

  co_mobile: {
    required: "Mobile number is required",
    pattern: {
      value: /^\d{10}$/,
      message: "Mobile number must be exactly 10 digits",
    },
  },

  email: {
    required: "Email ID is required",
    pattern: {
      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      message: "Invalid email address",
    },
  },

  turnover: {
    required: "Turnover is required",
    pattern: {
      value: /^[0-9]+$/,
      message: "Enter a valid number",
    },
    validate: {
      minValue: (value) =>
        parseInt(value) >= 50000 || "Turnover must be at least 50,000",
    },
  },

  loanAmount: {
    required: "Loan Amount is required",
    pattern: {
      value: /^[0-9]+$/,
      message: "Enter a valid number",
    },
    validate: {
      minValue: (value) =>
        parseInt(value) >= 100000 || "Loan Amount must be at least 1,00,000",
    },
  },

  homeLoanAmount: {
    required: "Loan Amount is required",
    pattern: {
      value: /^[0-9]+$/,
      message: "Enter a valid number",
    },
    validate: {
      minValue: (value) =>
        parseInt(value) >= 1000000 || "Loan Amount must be at least 10,00,000",
    },
  },


  validateEmiAmount: {
    required: "Existing EMI amount is required",
    pattern: {
      value: /\d+/,
      message: "Existing EMI amount is required",
    },
  },

  Pincode: {
    required: "Pincode is required",
    pattern: {
      value: /^\d{6}$/,
      message: "Pincode must be exactly 6 digits",
    },
  },

  State: {
    required: "State is required",
  },

  City: {
    required: "City is required",
  },

  relationship_with_applicant: {
    required: "Name is required",
    pattern: {
      value: /^[A-Za-z\s]+$/,
      message: "Enter a valid name",
    },
  },

  address: {
    required: "Address is required",
    pattern: {
      value: /^[A-Za-z\s]+$/,
      message: "Enter a valid address",
    },
  },

  fieldRequired: (label = "Name") => ({
    required: `${label} is required`,
    pattern: {
      value: /^[A-Za-z\s]+$/,
      message: `Enter a valid ${label.toLowerCase()}`,
    },
  }),
};

export const validateDOB = (dob) => {
  const today = new Date();

  const minAgeDate = new Date();
  minAgeDate.setFullYear(today.getFullYear() - 21);

  const maxAgeDate = new Date();
  maxAgeDate.setFullYear(today.getFullYear() - 59);

  if (new Date(dob) > today) {
    return "Date of Birth cannot be in the future";
  }

  if (new Date(dob) > minAgeDate) {
    return "Minimum age should be 21";
  }

  if (new Date(dob) < maxAgeDate) {
    return "Maximum age should be 58";
  }

  return true;
};


